<template>
  <div class="full-item flex flex-direction align-center justify-center">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      :label-position="UI.isMobile ? 'top' : 'left'"
      :label-width="UI.isMobile ? undefined : '80px'"
      style="width: 90%"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          placeholder="请输入用户名"
          clearable
          v-model="loginForm.username"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input
          placeholder="请输入密码"
          show-password
          clearable
          v-model="loginForm.password"
        ></el-input>
      </el-form-item>
      <el-form-item label="角色" prop="role">
        <el-select v-model="loginForm.role" placeholder="请选择">
          <el-option
            v-for="(role, index) in roles"
            :key="index"
            :label="role.label"
            :value="role.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <Vcode :show="isShow" @success="onVerifySuccess" @close="onVerifyClose" />

    <el-button
      class="login-button padding-xs margin-top"
      type="primary"
      size="mini"
      @click="loginSubmit()"
    >
      登录
    </el-button>

    <el-button
      class="login-button padding-sm"
      type="text"
      size="mini"
      @click="toChangePwd()"
    >
      忘记密码
    </el-button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { roleConsts } from '@/utils/consts';

import { login } from '@/servers/user.js';

import { setStorage } from '@/utils/storageUtils.js';
import Vcode from 'vue-puzzle-vcode';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  components: {
    Vcode,
  },

  data() {
    return {
      isShow: false,
      loginForm: {
        username: '',
        password: '',
        role: '',
      },
      roles: [],

      loginRules: {
        username: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur',
          },
        ],
        role: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  created() {
    setStorage('token', '');
    setStorage('refreshToken', '');
    for (let key in roleConsts) {
      this.roles.push(roleConsts[key]);
    }
  },

  methods: {
    ...mapMutations(['getUserState']),

    toChangePwd: function() {
      this.$router.push({
        name: 'changePwd',
      });
    },

    onVerifySuccess: function() {
      this.isShow = false;
      let that = this;
      login(this.loginForm, function(res) {
        setStorage('token', res.token);
        setStorage('refreshToken', res.refresh_token);
        setStorage('tokenExpiredTime', res.token_expired_time);
        that.User.hasLogin = true;
        setTimeout(function() {
          that.getUserState();
        }, 1000);
        that.$router.replace({
          name: 'info',
        });
      });
    },

    onVerifyClose: function() {
      this.isShow = false;
    },

    loginSubmit: function() {
      let that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          that.isShow = true;
        } else {
          showErrorMsg('请检查输入的参数.');
        }
      });
    },
  },
};
</script>
<style scoped>
.login-button {
  width: 200px;
}

.el-select {
  width: 100%;
}

.verify-bar-area {
  border-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/login.vue